module.exports = __webpack_public_path__ + "img/shay_no.35b3fac2.png";